<template>
  <div style="width:100%;">
    <v-card width="400" style="margin-left:auto;margin-right:auto;" outlined>
      <v-card-title>
        <h2>{{ $t("login.login") }}</h2>
      </v-card-title>
      <v-card-text>
        <v-form @submit="login">
          <v-text-field type="text" :label="$t('login.email')" v-model="email"></v-text-field>
          <v-text-field type="password" :label="$t('login.password')" v-model="password"></v-text-field>
          <v-btn type="submit" depressed>{{ $t("login.login") }}</v-btn>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="openRegister">{{ $t("login.register_now") }}</v-btn>
        <v-btn text @click="forgotPassword">{{ $t("login.forgot_password") }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { auth, storage, s_messaging } from "./../schmucklicloud";
import { Notifications, PushNotification } from "./../notification";

export default {
  async mounted() {},
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    openRegister() {
      this.$router.replace("/register");
    },
    forgotPassword() {
      this.$router.replace("/forgot");
    },
    async login(e) {
      e.preventDefault();

      var response = await auth.authorizeEmailPassword(
        this.email,
        this.password
      );
      if (response.status_code === 200) {
        localStorage.setItem("session_token", response.data.session_token);
        Notifications.show("Successfully signed in.");

        // Set the auth token to the objects
        storage.setAuthToken(response.data.session_token);
        s_messaging.setAuthToken(response.data.session_token);

        await PushNotification.turnOn();
        this.$router.replace("/");
      } else {
        Notifications.show(response.message);
      }
    }
  }
};
</script>

<style>
</style>